// src/dashboard-cliente/UserDashboard.js
import React, { useEffect, useMemo, useState } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";

import Cliente from "./Cliente";
import AdicionarLicenca from "./AdicionarLicenca";
import ListarLicencas from "./ListarLicencas";
import ListarPagamentos from "./ListarPagamentos";
import ResetSenhaUser from "./ResetSenhaUser";
import Suporte from "./Suporte";
import Downloads from "./Downloads";

import { useAuth } from "../auth";
import api from "../api";
import "./estilodashuser.css";

const UserDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { user, isAuthenticated, token, logout } = useAuth();
  const [nomeCliente, setNomeCliente] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !token || !user) {
      navigate("/login");
      return;
    }
    fetchClienteNome(user.id);
  }, [isAuthenticated, token, user, navigate]);

  const fetchClienteNome = async (userId) => {
    try {
      const response = await api.get(`/api/clientes/${userId}`);
      setNomeCliente(response.data?.nome || "Usuário");
    } catch (error) {
      console.error("Erro ao buscar o nome do cliente:", error);
      setNomeCliente("Usuário");
    }
  };

  const handleLogout = () => {
    try {
      // se seu useAuth tiver logout(), chama
      if (typeof logout === "function") logout();

      // limpeza defensiva (caso use localStorage)
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
    } catch (e) {
      console.error("Erro ao fazer logout:", e);
    } finally {
      navigate("/login");
    }
  };

  const menuItems = useMemo(
    () => [
      { path: "/dashboard-cliente/cliente", icon: "👤", label: "Meus Dados" },
      { path: "/dashboard-cliente/adicionar-licenca", icon: "➕", label: "Adicionar Licença" },
      { path: "/dashboard-cliente/listar-licencas", icon: "📜", label: "Minhas Licenças" },
      { path: "/dashboard-cliente/listar-pagamentos", icon: "💳", label: "Meus Pagamentos" },
      { path: "/dashboard-cliente/downloads", icon: "📥", label: "Downloads" },
      { path: "/dashboard-cliente/suporte", icon: "📱", label: "Suporte" },
      { path: "/dashboard-cliente/reset-senha", icon: "🔒", label: "Alterar Senha" },
    ],
    []
  );

  const isActive = (path) => location.pathname === path;

  const goTo = (path) => {
    navigate(path);
    setSidebarOpen(false); // fecha no mobile ao navegar
  };

  return (
    <div className="dash-shell">
      {/* Sidebar */}
      <aside className={`dash-sidebar ${sidebarOpen ? "is-open" : ""}`}>
        <div className="dash-brand">
          <div className="dash-brand-title">Quantum Trades</div>
          <div className="dash-brand-subtitle">Área do Cliente</div>
        </div>

        <nav className="dash-menu">
          {menuItems.map((item) => (
            <button
              key={item.path}
              className={`dash-menu-item ${isActive(item.path) ? "active" : ""}`}
              onClick={() => goTo(item.path)}
              type="button"
            >
              <span className="dash-menu-ico">{item.icon}</span>
              <span className="dash-menu-label">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="dash-sidebar-footer">
          <button className="dash-logout" onClick={handleLogout} type="button">
            <span className="dash-menu-ico">🚪</span>
            <span>Sair</span>
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="dash-main">
        <header className="dash-topbar">
          <button
            className="dash-burger"
            onClick={() => setSidebarOpen((v) => !v)}
            type="button"
            aria-label="Abrir menu"
          >
            ☰
          </button>

          <div className="dash-topbar-title">
            <div className="dash-welcome">Bem-vindo, {nomeCliente || "Usuário"}!</div>
            <div className="dash-welcome-sub">Gerencie licenças, pagamentos e downloads.</div>
          </div>
        </header>

        <section className="dash-content">
          <Routes>
            <Route path="cliente" element={<Cliente userId={user?.id} />} />
            <Route path="adicionar-licenca" element={<AdicionarLicenca userId={user?.id} />} />
            <Route path="listar-licencas" element={<ListarLicencas userId={user?.id} />} />
            <Route path="listar-pagamentos" element={<ListarPagamentos userId={user?.id} />} />
            <Route path="reset-senha" element={<ResetSenhaUser />} />
            <Route path="suporte" element={<Suporte />} />
            <Route path="downloads" element={<Downloads />} />
          </Routes>
        </section>
      </main>

      {/* Overlay mobile */}
      {sidebarOpen && <div className="dash-overlay" onClick={() => setSidebarOpen(false)} />}
    </div>
  );
};

export default UserDashboard;
